/**
 * @file   src\pages\QrScanner.tsx
 * @brief  <Scanner onScan={handleScanComplete} /> page.
 * @date   JUN, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import {React, useNavigate, useParams, useState , Modal,Button, useEffect,  } from "../utils/thirdpartyComponents";
import CWFooter from "src/components/CWFooter";
import { pageURLs } from "src/utils/pageUrls";
import { Scanner } from '@yudiel/react-qr-scanner';
import { MessageToaster } from "src/utils/toastUtil";
import { BayApi } from "src/utils/apiUrls";
import axios from '../config/axiosConfig';
import { BAY_AVAILABLE, BAY_BUSY, BAY_OUT_OF_SERVICE } from "src/utils/constants";
import PaymentfailModal from "../components/PaymentfailModal";
import SmallLoader from '../components/SmallLoader';
import { getFromLocalStorage } from "src/utils/helper";
import RadioButton from 'src/components/RadioButton';
import { CommonMessages } from "src/messages/validationMessages";
import { ServiceType } from "src/utils/enums";

const QrScanner = () => {
  // Initialize useNavigate
  const navigate = useNavigate();
  // Route information variable
  const params = useParams();
  // Instantiate MessageToaster
  const toaster = new MessageToaster();
  const [loading, setLoading] = useState(false);

  // payment fail modal
  const [showPaymentfailModal, setShowPaymentfailModal] = useState(false);
  const handleClosePaymentfailModal = () => setShowPaymentfailModal(false);
  const handleShowPaymentfailModal = () => setShowPaymentfailModal(true);

  const [selectedBayId, SetselectedBayId] = useState(1);
  // const [selectedBaySubsctiptionType,setSelectedBaySubsctiptionType] = useState(0)

  const  hasValidVacuumOrWashTime =(subData: any[]) =>  {
  return subData.some(sub => {
    const hasVacuum = sub.NoOfVacuumWash > 0;
    const hasVacuumRemaining = sub.NoOfVacuumWashRemaining > 0;

    const hasWashTime = sub.WashTime > 0;
    const hasWashTimeRemaining = sub.WashTimeRemaining > 0;

    if (hasVacuum) {
      return hasVacuumRemaining;
    } else {
      return hasWashTime && hasWashTimeRemaining;
    }
  });
}

const hasValidSelfServeOrWashTime = (subData: any[]) =>  {
  return subData.some(sub => {
    const hasVacuum = sub.NumberOfSelfServices > 0;
    const hasVacuumRemaining = sub.NumberOfSelfServicesRemaining > 0;

    const hasWashTime = sub.WashTime > 0;
    const hasWashTimeRemaining = sub.WashTimeRemaining > 0;

    if (hasVacuum) {
      return hasVacuumRemaining;
    } else {
      return hasWashTime && hasWashTimeRemaining;
    }
  });
}


  const washSelectionChecking = async(result: any) => {
      const bayId = result[0]?.rawValue;
      // const bayId ='454'
      if(parseInt(bayId) > 0) {
        const timezoneOffset = (new Date()).getTimezoneOffset();
        localStorage.setItem('selectedBay',bayId)
        SetselectedBayId(bayId)
          setLoading(true); // Show loader
          const { data } = await axios.get(BayApi.CHECK_WASHES_AVAILABLE, {
            params: {
                lat: 0,
                lng: 0,
                bayId : bayId,
                scan : true,
                offset: timezoneOffset
            }
          });
          setLoading(false); // Hide loader
          if(data.error === 0)
          {
            if(data.data.subStatus.bayType == 0 )
            {
              if(data.data.subStatus.hasSingleWash === 0 && data.data.subStatus.hasSubscription === 0  && data.data.subStatus?.hasBulkWash ===0) { //Not purchased both subscription and single wash
                navigate(`/${params.carwashname}/${pageURLs.subscriptionandwashprice}?showSingleWash=true&scan=true&fromTab=subscriptions`,{ state: { bayId: bayId }});
              }
              else{
                navigate(`/${params.carwashname}/${pageURLs.selectwash}?scan=true`);
              }

            }
            else if(data.data.subStatus.bayType != ServiceType.bayTunnel )
            {
                if(data.data.freeVacuumSingleUse==true && data.data.freeVacuumSingleUseId!=0){
                  navigate(`/${params.carwashname}/${pageURLs.selfService}?freeVacuum=true`, { state: { UserSubscriptionID: data.data.freeVacuumSingleUseId, bayId: bayId } });
                }
                else if((data.data.subStatus.hasSingleWash === 1 && data.data.subStatus.hasSubscription === 1 ) || data.data.subData?.length>1){
                  if(data.data.subStatus.bayType == ServiceType.vacuumWash && hasValidVacuumOrWashTime(data.data.subData)==false)
                  {
                    toaster.toastError(CommonMessages.no_freevauum_remaining);
                  navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${data.data.subStatus.bayType}`, { state: { bayId: bayId } });
                  }
                  else if(data.data.subStatus.bayType == ServiceType.selfServe && hasValidSelfServeOrWashTime(data.data.subData)==false)
                  {
                    toaster.toastError(CommonMessages.no_freeselfserve_remaining);
                    navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${data.data.subStatus.bayType}`, { state: { bayId: bayId } });
                  }
                  else
                  {
                    navigate(`/${params.carwashname}/${pageURLs.SelfServeSelectwash}?scan=true&bayTypeId=${data.data.subStatus.bayType}`);

                  }

              }
              else if(data.data.subData?.length > 0 && data.data.subData[0].HasVacuumWash == 1 &&   data.data.subStatus.bayType == ServiceType.vacuumWash && data.data.subData[0].SubscriptionType != 1){
                if(data.data.subData[0].NoOfVacuumWashRemaining >0)
                {
                  navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=true&freeVacuum=true`,{ state: { UserSubscriptionID: data.data.subData[0].UserSubscriptionID,bayId:bayId }});

                }
                else{
                  toaster.toastError(CommonMessages.no_freevauum_remaining);
                  navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${data.data.subStatus.bayType}`, { state: { bayId: bayId } });
                }
              }
              else if(data.data.subData?.length > 0 && data.data.subData[0].HasSelfService == 1 &&   data.data.subStatus.bayType == ServiceType.selfServe && data.data.subData[0].SubscriptionType != 1){
                if(data.data.subData[0].NumberOfSelfServicesRemaining >0)
                {
                  navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=true&freeSelfServe=true`,{ state: { UserSubscriptionID: data.data.subData[0].UserSubscriptionID,bayId:bayId }});

                }
                else{
                  toaster.toastError(CommonMessages.no_freeselfserve_remaining);
                  navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&nowashTime=true&bayselect=true&fromTab=subscriptions&bayTypeId=${data.data.subStatus.bayType}`, { state: { bayId: bayId } });
                }
              }
              else if(data.data.subStatus.hasSingleWash === 0 && data.data.subStatus.hasSubscription === 0  && data.data.subStatus.hasBulkWash === 0) {
                navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&scan=true&fromTab=subscriptions&bayTypeId=${data.data.subStatus.bayType}`,{ state: { bayId: bayId }});

                
              }
              else if((data.data.subStatus.hasSubscription === 1 || data.data.subStatus.hasBulkWash === 1 )&& data.data.subData?.length > 0 && data.data.subData[0].WashTimeRemaining <= 0){
                  toaster.toastError(CommonMessages.no_wash_time_remaining);
                      navigate(`/${params.carwashname}/${pageURLs.selfServeSubscriptionandwashprice}?showSingleWash=true&bayselect=true&fromTab=subscriptions&nowashTime=true`,{ state: { bayId: bayId }});
                  }
              //  else if ((data.data.subStatus.hasSingleWash === 1 || data.data.subStatus.hasSubscription === 1) && data.data.subData.length > 0 && data.data.subData[0].WashTimeRemaining > 0) {
              //               navigate(`/${params.carwashname}/${pageURLs.selfService}?bayTypeId=${data.data.subStatus.bayType}`, { state: { UserSubscriptionID: data.data.subData[0].UserSubscriptionID, bayId: bayId } });
              //             }
                  else{
                    navigate(`/${params.carwashname}/${pageURLs.selfService}?scan=true`,{ state: { UserSubscriptionID: data.data.subData[0].UserSubscriptionID,bayId:bayId }});
                  }
              }

            } else {
              toaster.toastError(data.message);
              navigate(`/${params.carwashname}/${pageURLs.home}`);
            } 
          
      } else {
        toaster.toastError('Invalid QR Code.');
        navigate("/" + params.carwashname + "/" + pageURLs.home);
      }
  }

  return (
    <div className="common-content-wrap home-content-wrap pb-70"> 
      <div className="inner-content-wrap">
          <div className="common-header multi-group-header">
              <div className="pe-4 ps-4 pt-0 pb-0 h-100">
                  <div className="common-header-inner">
                    
                      <div className="info">
                        <h4 className="pb-1">Scan QR code</h4>
                        <p>Place QR code inside the frame to scan.</p>
                      </div>
                      
                  </div>
              </div>
          </div>
           <div className="qr-wrapper">
            <Scanner onScan={washSelectionChecking}  />
            <div className="qr-close-btn">
              <a href={pageURLs.home} title="close"><svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44"><g transform="translate(-206 -587)"><circle cx="22" cy="22" r="22" transform="translate(206 587)" fill="rgba(6,6,6,0.33)"/><g transform="translate(223 604)"><line x1="15.311" transform="translate(0 0) rotate(45)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/><line x1="15.311" transform="translate(0 10.827) rotate(-45)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"/></g></g></svg></a>
              </div>
          </div> 
      </div>
      {loading && <SmallLoader />}
      <CWFooter activeLink="Home"/>

      {/* <Modal
        show={showWashTypeSelectionModal}
        onHide={HideWashSelectionModal}
        centered
        className='notification-modal'
      >
        <Modal.Body className='text-center'>
          <h6>{washSelectionConfirmationMessage}</h6>
            
        </Modal.Body>
        <Modal.Footer className='d-flex flex-column'>
          {subscriptionOnlyAvailable === true ?
          <>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={(e) => { handleScanComplete(2) }}>Use Subscription</Button>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={purchaseSingleWash}>Buy Single Wash</Button>
          </> : 
          <>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={(e) => { handleScanComplete(2) }}>Subscription</Button>
            <Button variant="primary" className='primary-btn btn-main m-0 w-100'  onClick={(e) => { handleScanComplete(1) }}>Single Wash</Button>
          </>
          }
        </Modal.Footer>
      </Modal> */}

      <PaymentfailModal
      show={showPaymentfailModal}
      onHide={handleClosePaymentfailModal}
      />
  </div>
  )
  
};

export default QrScanner;
